import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, formatRupiah } from "@/lib/api";

const todayWIB = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Jakarta" });

const Row = ({ r, total }) => (
  <tr className={`border-t border-white/5 ${total ? "bg-[#13131a] font-bold" : "bg-[#0d0d12]"}`} data-testid={total ? "inject-summary-total" : `inject-summary-row-${r.staff}`}>
    <td className="px-4 py-3 font-mono">{total ? "TOTAL" : r.staff}</td>
    <td className="px-4 py-3">{r.topup_count}x · {formatRupiah(r.topup_rp)}</td>
    <td className="px-4 py-3">{r.bongkar_count}x · <span className="text-[#ffd700]">{r.bongkar_b}B</span> · {formatRupiah(r.bongkar_rp)}</td>
    <td className="px-4 py-3">{r.topup_count + r.bongkar_count}x</td>
  </tr>
);

export const InjectSummary = ({ refreshKey }) => {
  const [date, setDate] = useState(todayWIB);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/inject/summary", { params: { date } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [date, refreshKey]);

  return (
    <section className="rk-glass rounded-2xl p-6" data-testid="inject-summary">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-bold">Ringkasan Inject Harian</h3>
          <p className="text-xs text-zinc-500">Total inject per staf (waktu WIB)</p>
        </div>
        <input type="date" value={date} max={todayWIB()} onChange={(e) => e.target.value && setDate(e.target.value)} className="rk-input !w-auto [color-scheme:dark]" lang="id-ID" data-testid="inject-summary-date" />
      </div>
      <div className="mt-4 overflow-x-auto rounded-xl border border-white/5">
        <table className="w-full text-sm">
          <thead className="bg-[#13131a] text-left text-[11px] uppercase tracking-widest text-zinc-500">
            <tr><th className="px-4 py-3">Staf</th><th className="px-4 py-3">Top Up</th><th className="px-4 py-3">Bongkar</th><th className="px-4 py-3">Jumlah</th></tr>
          </thead>
          <tbody>
            {!data ? null : data.rows.length === 0 ? (
              <tr><td colSpan={4} className="p-6 text-center text-zinc-500" data-testid="inject-summary-empty">Belum ada inject pada tanggal ini.</td></tr>
            ) : (
              <>
                {data.rows.map((r) => <Row key={r.staff} r={r} />)}
                <Row r={data.totals} total />
              </>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};
